export default __webpack_public_path__ + "static/inner-belief_small-image_2-cc40403ce18b9ff2371e15ab2c1eec26.webp";